import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SurveyActions } from '../actions/survey.actions';
import {
  SurveyStateFilterKey,
  SurveyStateFilters,
  SurveyRequestContext,
} from '../survey-state.model';
import { SurveySort } from '../../models/survey.model';

@Injectable({ providedIn: 'root' })
export class SurveyActionFacade {
  private readonly _store = inject(Store);

  public init(context: SurveyRequestContext): void {
    this._store.dispatch(SurveyActions.init({ context }));
  }

  public setFilters(filters: Partial<SurveyStateFilters>): void {
    this._store.dispatch(SurveyActions.setFilters({ filters }));
  }

  public setFilter<K extends SurveyStateFilterKey>(
    key: K,
    value: SurveyStateFilters[K],
  ): void {
    this._store.dispatch(
      SurveyActions.setFilters({
        filters: { [key]: value } as Partial<SurveyStateFilters>,
      }),
    );
  }

  /** Reset all filters to defaults and re-fetch from page 1. */
  public resetFilters(): void {
    this._store.dispatch(SurveyActions.resetFilters());
  }

  /** Merge partial sort overrides and re-fetch from page 1. */
  public setSort(sort: SurveySort): void {
    this._store.dispatch(SurveyActions.setSort({ sort }));
  }

  public reload(): void {
    this._store.dispatch(SurveyActions.reload());
  }
  public loadNextPage(): void {
    this._store.dispatch(SurveyActions.loadNextPage());
  }
}
